import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist, mergeChanged} from "../../../Services/BrowserDatabaseFunctions";

export function addEventNote(_event_id, _note) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure notes is an array
                const notes = Array.isArray(event.notes)
                    ? event.notes.slice()
                    : [];

                // prefer matching by id
                const idx = notes.findIndex(m =>
                    m &&
                    _note &&
                    m.id != null &&
                    _note.id != null &&
                    String(m.id) === String(_note.id)
                );

                if (idx >= 0) {
                    // update existing note; merge only defined fields
                    const base = notes[idx];
                    const patch = _note;
                    const merged = { ...base };
                    Object.keys(patch).forEach(k => {
                        if (typeof patch[k] !== "undefined") merged[k] = patch[k];
                    });
                    notes[idx] = merged;
                } else {
                    // add new note
                    notes.push(_note);
                }

                // write back
                event.notes = notes;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Note with ID ${_note.id} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in addEventNote:", error);
            throw error;
        });
}

export function updateEventNote(_event_id, _note) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure notes is an array
                const notes = Array.isArray(event.notes)
                    ? event.notes.slice()
                    : [];

                // prefer matching by id
                const idx = notes.findIndex(m =>
                    m &&
                    _note &&
                    m.id != null &&
                    _note.id != null &&
                    String(m.id) === String(_note.id)
                );

                if (idx >= 0) {
                    const { merged, changed } = mergeChanged(notes[idx], _note);
                    if (changed) notes[idx] = merged;
                } else {
                    // add new note
                    notes.push(_note);
                }

                // write back
                event.notes = notes;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Note with ID ${_note.id} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in updateEventNote:", error);
            throw error;
        });
}

export function deleteEventNote(_event_id, _note_id) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite"); // Use 'readwrite' mode for updates
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                const notes = Array.isArray(event.notes)
                    ? event.notes
                    : [];

                // Filter out the note with the specified ID
                const updatedNotes = notes.filter(note => {
                    if (!note) return false;
                    return String(note.id) !== String(_note_id);
                });

                // Update the event with the modified notes array
                event.notes = updatedNotes;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Put the updated event back into the object store
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Note with ID ${_note_id} in Event with ID ${_event_id} deleted successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in deleteEventNote:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}

